require("!!/Users/edson/projetos_react/anteros-react/node_modules/script-loader/addScript.js")(require("!!/Users/edson/projetos_react/anteros-react/node_modules/raw-loader/index.js!/Users/edson/projetos_react/anteros-react/node_modules/emojionearea/dist/emojionearea.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/emojionearea/dist/emojionearea.js
// module id = 1472
// module chunks = 0